<template>
  <div>
    <router-link
      class="d-flex align-items-center"
      :to="{name: 'organisation-detail', params: { slug: organisationSlug } }"
      v-if="isActive"
    >
      <img
        v-if="logoUrl"
        :src="logoUrl"
        alt=""
        class="d-block img-logo mr-2 img-fluid"
      />
      {{ organisationName }}
    </router-link>
    <div v-else>
      <img
        v-if="logoUrl"
        :src="logoUrl"
        alt=""
        class="d-block img-logo mr-2 img-fluid"
      />
      {{ organisationName }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrganisationRouterLink',
  props: {
    isActive: {
      type: Boolean,
      default() {
        return false;
      },
    },
    logoUrl: {
      type: String,
      required: false,
    },
    organisationName: {
      type: String,
      required: true,
    },
    organisationSlug: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.img-logo {
  height: 25px;
  width: auto;
}
</style>
